<template>
  <dl v-if="hasPriceRange">
    <dt @click="toggleFilter()" :class="filterOpen ? '_visible' : ''">{{ $t('Price') }}</dt>
    <dd v-show="filterOpen">
      <div class="price__filter">
        <div class="custom__controls">
          <input type="number" v-model.number="value[0]"/>
          <span class="show-for-small-only">-</span>
          <input type="number" v-model.number="value[1]"/>
          <button @click="changePrice()" class="show-for-small-only" type="submit"></button>
        </div>
        <div v-show="showError" class="_error">{{ $t('Enter a correct value') }}</div>
        <vue-slider @drag-end="changePrice()" :min="minVal" :max="maxVal" v-model="value" :dot-size="24" :height="sliderHeight" :silent="true"></vue-slider>
      </div>
    </dd>
  </dl>
</template>

<script lang="ts">
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';

  @Component({
    name: 'price-filter',
    components: {
      VueSlider
    }
  })

  export default class extends Vue {
    @Prop() readonly filter!: object;
    @Prop() readonly dataSource: string;

    private showError: boolean = false;
    private readonly mediumBreakpoint: number = 940;
    readonly smallBreakpoint: number = 768;
    private filterOpen: boolean = window.outerWidth >= this.smallBreakpoint;
    private value: Array<number> = [this.minValue, this.maxValue];
    private minVal: number = this.filter?.['minimum_range'] ?? 0;
    private maxVal: number = this.filter?.['maximum_range'] ?? 0;
    private sliderHeight: number = window.outerWidth > this.mediumBreakpoint ? 3 : 2;

    private get hasPriceRange(): boolean {
      return (this.filter?.['maximum_range'] ?? 0) > 0;
    }

    @Watch('filter')
    private syncData(): void {
      if (!this.filter) {
        return;
      }
      this.minVal = this.filter['minimum_range'] ?? 0;
      this.maxVal = this.filter['maximum_range'] ?? 0;
      this.value = [this.minValue, this.maxValue];
    }

    private get minValue(): number {
      const min = this.filter?.['minimum_value'] ?? 0;
      const range = this.filter?.['minimum_range'] ?? 0;
      return min > 0 && min >= range ? min : range;
    }

    private get maxValue(): number {
      const max = this.filter?.['maximum_value'] ?? 0;
      const range = this.filter?.['maximum_range'] ?? 0;
      return max > 0 && max <= range ? max : range;
    }

    private toggleFilter(): void {
      this.filterOpen = !this.filterOpen;
    }

    private get validateInput(): boolean {
      return this.value[1] > this.value[0] && this.value[0] > 0;
    }

    private changePrice(): void {
      if (this.validateInput) {
        this.showError = false;
        let options = {
          minPrice: this.value[0],
          maxPrice: this.value[1]
        };
        this.$store.dispatch(`${this.dataSource}/updatePriceFilter`, options);
      } else {
        this.showError = true;
      }
    }
  }
</script>
